export default __webpack_public_path__ + "/dist/images/message-user-icon.svg";